export const formatList = (list) => (Array.isArray(list) && list.length > 0 ? list.join(', ') : '');

export const safeJsonStringify = (value) => {
  const seen = new WeakSet();
  try {
    return JSON.stringify(
      value,
      (_key, val) => {
        if (typeof val === 'bigint') return val.toString();
        if (typeof val === 'function') return '[function]';
        if (!val || typeof val !== 'object') return val;
        if (seen.has(val)) return '[circular]';
        seen.add(val);
        return val;
      },
      0
    );
  } catch (_err) {
    // Last resort: avoid throwing during export.
    try {
      return String(value);
    } catch (_err2) {
      return '';
    }
  }
};

export const safeExportValue = (value) => {
  if (value === null || value === undefined) return '';
  if (value instanceof Date) {
    const time = value.getTime();
    return Number.isNaN(time) ? '' : value.toISOString();
  }
  const type = typeof value;
  if (type === 'string' || type === 'number' || type === 'boolean') return value;

  if (Array.isArray(value)) {
    if (value.length === 0) return '';
    const allPrimitive = value.every(
      (item) => item === null || ['string', 'number', 'boolean'].includes(typeof item)
    );
    if (allPrimitive) return value.filter((item) => item !== null && item !== undefined).join(', ');
    return safeJsonStringify(value);
  }

  if (type === 'object') return safeJsonStringify(value);

  try {
    return String(value);
  } catch (_err) {
    return '';
  }
};

export const safeTsvCell = (value) => {
  const normalized = safeExportValue(value);
  // Keep TSV rows single-line and tab-safe.
  if (typeof normalized === 'string') return normalized.replace(/\t/g, ' ').replace(/\r?\n/g, '\\n');
  return normalized;
};

export const copyToClipboard = async (text) => {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return true;
  }
  try {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(textarea);
    return ok;
  } catch (_err) {
    return false;
  }
};

export const pickFirstValue = (row, keys) => {
  for (const key of keys) {
    const value = row ? row[key] : undefined;
    if (value === null || value === undefined) continue;
    if (typeof value === 'string' && value.trim() === '') continue;
    return value;
  }
  return null;
};
